import {LoginEffects} from '@core/store/effects/login.effect';
import {AppSettingEffects} from '@core/store/effects/app-settings.effect';
import {CartEffects} from '@core/store/effects/cart.effect';

export const effects: any = [LoginEffects, AppSettingEffects, CartEffects];
